<template>
    <div class="main">
        <div
            v-xss="content"
            class="ql-editor"/>
    </div>
</template>
<script>
import { getPrivacyPolicy } from "./api/api";
import { qs, ua } from "@kkmh/utils";
import { set_title } from "@kk/h5-sdk";
export default {
    data(){
        return {
            title: "",
            content: ""
        };
    },
    created(){
        this.getList();
    },
    methods:{
        getList() {
            const { type = 1 } = qs;
            const { kkmh, iphone } = ua;
            getPrivacyPolicy({ type }).then(res => {
                const {code, data} = res.data;
                
                if (code != 200) return;

                this.title = data.policy_info.title || "快看漫画";
                this.content = data.policy_info.content || "暂无内容";

                if ( kkmh && iphone ) {
                    set_title({
                        title: this.title
                    });
                } else {
                    document.title = this.title;
                }
                this.$nextTick(() => {
                    const dom = document.getElementsByClassName("ql-align-center");
                    const adom = document.getElementsByTagName("a");
                    const maindom = document.getElementsByClassName("ql-editor");
                    if (dom.length) {
                        for (var i = 0 ; i < dom.length ; i++) {
                            dom[i].style.textAlign = "center";
                        }
                    }
                    if (adom.length) {
                        for (var j = 0 ; j < adom.length ; j++) {
                            adom[j].style.wordBreak = "break-all";
                        }
                    }
                    if (maindom.length) {
                        for (var k = 0 ; k < maindom.length ; k++) {
                            maindom[k].style.padding = "12px 15px";
                        }
                    }
                });
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@/assets/sass/vws.scss';

body{
    background: #fff;
}

.main{
    // padding:vws(30px);
    font-size:vws(24px);
    line-height: 1.6;
    color: #444;
}

/v-deep/ .ql-align-center {
    text-align: center!important;
}

/deep/ a {
    word-break: break-all!important;
}

</style>


// WEBPACK FOOTER //
// src/pages/normal/protocol/app.vue